export default __webpack_public_path__ + "static/media/fishfarms.f83037e0.jpg";